import initAjaxSelect2 from "@scripts/services/init-ajax-select2";
import { getStore } from "@scripts-admin/utils/safe-store";

export default function useAjaxSelect2Store(component, cfg = {}) {
    const {
        selector,
        ref,
        storeName,
        storeProp,
        valueProp,
        multiple = false,
        restPath,
        ajaxParams = () => ({}),
        processResults,
        placeholder,
        dropdownParent = null,
        onChange,
    } = cfg;

    const st = storeName ? (getStore(storeName) || {}) : null;
    let instance = null;
    const normalize = (val) => {
        if (multiple) return (Array.isArray(val) ? val : (val ? [val] : [])).map(Number);
        if (val === undefined || val === null || val === '') return null;
        return Array.isArray(val) ? Number(val[0]) : Number(val);
    };
    const valuesEqual = (a, b) => JSON.stringify(normalize(a)) === JSON.stringify(normalize(b));
    const syncSelect = (value) => {
        if (!instance) return;
        instance.val(multiple ? normalize(value) : normalize(value)).trigger("change.select2");
    };

    const select2Config = initAjaxSelect2(
        `${rozetka_learnpress_global.restApi.url}${restPath}`,
        {},
        rozetka_learnpress_global.restApi.nonce,
        processResults
    );

    const originalData = select2Config.ajax.data;
    select2Config.ajax.data = (params) => ({
        ...originalData(params),
        ...(typeof ajaxParams === "function" ? ajaxParams.call(component) : ajaxParams || {})
    });

    jQuery(() => {
        const el = ref ? component.$refs[ref] : document.querySelector(selector);
        instance = jQuery(el).select2({
            placeholder,
            multiple,
            dropdownParent,
            ...select2Config,
        });

        instance.on("change.select2", (event) => {
            const newValue = normalize(jQuery(event.currentTarget).val());
            if (!valuesEqual(component[valueProp], newValue)) {
                component[valueProp] = multiple ? newValue : newValue ?? null;
            }
            if (st && storeProp) st[storeProp] = component[valueProp];
            onChange?.call(component, component[valueProp]);
        });

        syncSelect(component[valueProp]);
    });

    component.$watch(valueProp, (value) => syncSelect(value));

    if (st && storeProp) {
        component.$watch(() => st[storeProp], (value) => {
            if (!valuesEqual(component[valueProp], value)) {
                component[valueProp] = value;
            }
        });
    }

    return {
        get instance() { return instance; },
        destroy() {
            if (instance) instance.select2("destroy");
            instance = null;
        },
    };
}
